import React from "react";
import { Button, Col, Row, Table, Typography } from "antd";
import { BacktestAction } from "@/features/backtest";
import { useTableData } from "./hook";
import { useDispatch } from "react-redux";
import { PlusCircleOutlined } from "@ant-design/icons/lib";

import styles from "./styles.less";

type Props = {
  isBuy: boolean;
};

export default ({ isBuy }: Props) => {
  const dispatch = useDispatch();
  const { columns, strategy } = useTableData(isBuy);

  return (
    <Row justify={"space-between"}>
      <Typography.Text strong>{isBuy ? "Buy Strategy" : "Sell Strategy"}</Typography.Text>
      <Button onClick={addStrategy} icon={<PlusCircleOutlined />} className={styles.btn}>
        Add {isBuy ? "Buy" : "Sell"} Strategy
      </Button>
      <Col span={24}>
        <Table dataSource={strategy} columns={columns} pagination={false} size={"small"} />
      </Col>
    </Row>
  );

  function addStrategy() {
    dispatch(
      BacktestAction.updateStrategy({
        [isBuy ? "buy" : "sell"]: [
          ...strategy,
          {
            indicator1: [],
            param1: 0,
            compare: ">=",
            indicator2: [],
            param2: 0,
            and: true
          }
        ]
      })
    );
  }
};
